<div class="row">
  <div class="col">
    <h3>{{ 'i18n.domain.client-administration.overview.title' | translate }}</h3>
  </div>
</div>
<div class="row align-items-center">
  <div class="col-12">
    <div  class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
      <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}" [(checked)]="showInactive" cssClass="checkbox-large ms-auto"></ejs-checkbox>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid
    class="grid-with-toolbar"
    width='100%'
    rowHeight='38'
    [dataSource]='data'
    [allowSorting]='true'
    [filterSettings]='filterSettings'
    [allowFiltering]='true'
    [allowPaging]='true'
    [pageSettings]='pageSettings'
    [editSettings]='editSettings'
    [searchSettings]="searchOptions"
    (actionBegin)="actionBegin($event)"
    (actionComplete)="actionComplete($event)"
    (commandClick)="commandClick($event)">
    <ng-template #toolbarTemplate let-data>
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.client-administration.overview.add' | translate" prefixIcon='e-icons icon-add' (click)="onAdd()"></e-item>
        </e-items>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      <e-column field='id'
        [visible]='false'
        headerText='Client ID'
        [isPrimaryKey]='true'></e-column>
      <e-column field='name'
        type="string"
        headerText="{{'i18n.shared.fields.name' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='address'
        type="string"
        headerText="{{'i18n.shared.fields.address' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='zip'
        type="string"
        headerText="{{'i18n.shared.fields.zip' | translate}}"
        clipMode='EllipsisWithTooltip' width='110px'>
      </e-column>
      <e-column field='city'
        type="string"
        headerText="{{'i18n.shared.fields.city' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='email'
        type="string"
        headerText="{{'i18n.shared.fields.email' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='phoneNumber'
        type="string"
        headerText="{{'i18n.shared.fields.phone' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column [headerText]="'i18n.shared.fields.active' | translate" field="isActive" [visible]='showInactive' [filter]="isActiveFilter">
        <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'isActive')}}</ng-template>
        <ng-template #template let-data>
          @if (data.isActive) {
            <div class="e-icons icon-checkmark align-middle"></div>
          }
        </ng-template>
      </e-column>
      <e-column headerText="" [commands]='gridCommands'></e-column>
    </e-columns>
    <ng-template #editSettingsTemplate let-data>
      <app-client-administration-edit-form [clientEditForm]="gridEditForm"></app-client-administration-edit-form>
    </ng-template>
  </ejs-grid>
</div>
